// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2f_0y","header":"Messages_header__2N7XP"};